import { ILocalStorageKey } from '@/types/ILocalStorageKey';
import { getLocalStorageKey } from '@/utils/getLocalStorageKey';

export const setLocalStorageValue = <T extends object | string = object>(keyName: ILocalStorageKey, value: T): void => {
  const fullKey = getLocalStorageKey(keyName);
  try {
    const valueSerialized = JSON.stringify(value);
    localStorage.setItem(fullKey, valueSerialized);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    /* do nothing */
  }
};
